<template>
  <div>
    <my-notification :icon="'joomla'">
      <template #title>
        {{ $t('compCarbonDocsTeam.title-1') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>Tamara Ben Ari : <em>INRAE, Montpellier</em></li>
          <li>Olivier Berné : <em>IRAP, Toulouse</em></li>
          <li>
            Odile Blanchard : <em>Université Grenoble Alpes, Grenoble</em>
          </li>
          <li>Jérôme Mariette : <em>INRAE, Toulouse</em></li>
        </ul>
      </div>
    </my-notification>
    <br />
    <my-notification :icon="'cogs'">
      <template #title>
        {{ $t('compCarbonDocsTeam.title-2') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>
            Olivier Aumont : <em>IRD, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-8')
            }}, {{ $t('compCarbonDocsTeam.desc-7') }})
          </li>
          <li>
            David Benaben : <em></em> ({{ $t('compCarbonDocsTeam.desc-11') }}:
            GENCI)
          </li>
          <li>
            Cyril Bernard : <em>Université de Lille, Lille</em> ({{
              $t('compCarbonDocsTeam.desc-10')
            }})
          </li>
          <li>
            Françoise Berthoud : <em>CNRS, Grenoble</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: GENCI)
          </li>
          <li>
            Christophe Brun : <em>Sorbonne Université, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }})
          </li>
          <li>
            Samuel Calvet : <em>IN2P3, CNRS, Clérmont-Ferrand</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: CERN)
          </li>
          <li>
            Yann Coadou : <em>IN2P3, CNRS, Marseille</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: CERN)
          </li>
          <li>
            Franck Davoine : <em>CNRS, Compiègne</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }})
          </li>
          <li>
            André Estevez-Torres : <em>CNRS, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }}, {{ $t('compCarbonDocsTeam.desc-10') }})
          </li>
          <li>
            Marie-Alice Foujols : <em>CNRS, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: GENCI)
          </li>
          <li>
            Frederic Huard : <em>INRAE, Avignon</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: {{ $t('compCarbonDocsTeam.desc-12') }})
          </li>
          <li>
            Jürgen Knödlseder : <em>CNRS, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: Astro)
          </li>
          <li>
            Anne-Laure Ligozat : <em>CNRS, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: GENCI)
          </li>
          <li>
            Marianne De Paepe : <em>INRAE, Jouy en Josas</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }})
          </li>
          <li>
            Laurent Jeanneau : <em>CNRS, Rennes</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }})
          </li>
          <li>
            Emmanuel Lellouch : <em>CNRS, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-8')
            }})
          </li>
          <li>
            Laurent Pagani : <em>CNRS, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-8')
            }})
          </li>
          <li>
            Mélissa Ridel : <em>Sorbonne Université, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: CERN)
          </li>
          <li>
            Sophie Valcke : <em>CERFACS, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-11')
            }}: GENCI)
          </li>
          <li>
            Lucile Zribi : <em>CEA, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-7')
            }})
          </li>
        </ul>
      </div>
    </my-notification>
    <br />
    <my-notification :icon="'keyboard-o'">
      <template #title>
        {{ $t('compCarbonDocsTeam.title-3') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>
            Philippe Bardou : <em>INRAE, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-1')
            }})
          </li>
          <li>
            Mickael Coriat : <em>Université Paul Sabatier, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-9')
            }})
          </li>
          <li>
            Gael Guennebaud : <em>INRIA, Talence</em> ({{
              $t('compCarbonDocsTeam.desc-2')
            }}, {{ $t('compCarbonDocsTeam.desc-9') }},
            {{ $t('compCarbonDocsTeam.desc-11') }}: GENCI)
          </li>
          <li>
            Fabrice Jammes : <em>CNRS, Clermont-Ferrand</em> ({{
              $t('compCarbonDocsTeam.desc-4')
            }})
          </li>
          <li>
            Elise Maigne : <em>INRAE, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-3')
            }})
          </li>
          <li>
            Gérald Salin : <em>INRAE, Toulouse</em> ({{
              $t('compCarbonDocsTeam.desc-4')
            }})
          </li>
          <li>
            Sophie Servan : <em>DESY, Hambourg</em> ({{
              $t('compCarbonDocsTeam.desc-5')
            }})
          </li>
          <li>
            Matthieu Simonin : <em>INRIA, Rennes</em> ({{
              $t('compCarbonDocsTeam.desc-9')
            }})
          </li>
          <li>
            Joël Thanwerdas : <em>CEA, Paris</em> ({{
              $t('compCarbonDocsTeam.desc-6')
            }})
          </li>
          <li>
            Corentin Durand : <em>INRIA, Rennes(Stagiaire - 2024)</em> ({{
              $t('compCarbonDocsTeam.desc-9')
            }})
          </li>
        </ul>
      </div>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Team',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
